var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonLogoFitgenieMonogram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "common_logo_fitgenie_monogram_svg__a",
    d: "M0 0h100v65.217H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 17.391)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "common_logo_fitgenie_monogram_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#common_logo_fitgenie_monogram_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#131A14",
    mask: "url(#common_logo_fitgenie_monogram_svg__b)",
    d: "M7.45 15.802V34.13h23.788v7.106H7.45v23.981H0V8.696h34.783v7.106H7.449"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.87 28.26a24.67 24.67 0 00-14.13-14.13A24.671 24.671 0 0085.87 0 24.673 24.673 0 00100 14.13a24.673 24.673 0 00-14.13 14.13",
    fill: "#21AE5F",
    mask: "url(#common_logo_fitgenie_monogram_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.46 35.145H63.295v7.16h22.068c-2.767 9.106-11.237 15.752-21.233 15.752-12.235 0-22.19-9.957-22.19-22.196 0-12 9.57-21.799 21.475-22.18v-7.16c-15.852.384-28.632 13.392-28.632 29.34 0 16.187 13.165 29.356 29.347 29.356 16.183 0 29.348-13.17 29.348-29.356 0-.24-.012-.478-.018-.716",
    fill: "#131A14",
    mask: "url(#common_logo_fitgenie_monogram_svg__b)"
  }))));
}

export default SvgCommonLogoFitgenieMonogram;